let animation = lottie.loadAnimation({
      container: document.getElementById('animationLeafContainer'),
      path: 'https://cdn.shopify.com/s/files/1/0680/0860/7969/files/Leaf.json?v=1714598654',
      renderer: 'canvas',
      loop: true,
      autoplay: true,
      name: "Leaf Animation",  
    }),
    animationDrink = lottie.loadAnimation({
        container: document.getElementById('animationDrinkContainer'),
        path: 'https://cdn.shopify.com/s/files/1/0680/0860/7969/files/drink.json?v=1719524217',
        renderer: 'canvas',
        loop: true,
        autoplay: true,
        name: "Drink Animation",  
    }),
    animationLeaf = lottie.loadAnimation({
      container: document.getElementById('animationMonsterraContainer'),
      path: 'https://cdn.shopify.com/s/files/1/0680/0860/7969/files/Leaf.json?v=1714598654',
      renderer: 'canvas',
      loop: true,
      autoplay: true,
      name: "Monsterra Animation",  
  });